<template>
  <!-- _________________________ VALIDATE ACCOUNT _________________________ -->
  <div id="login-div">

    <h1 class="page-title mt-2">
      {{ $t('register.End') }}
    </h1>

    <h2 v-html="$t('register.sendCode', { mail :username })" class="content mt-4"></h2>

    <b-alert :show.sinc="ui.showError" variant="danger" class="mt-5">
      {{ $t('ValidateAccount.error') }}
      <br/>
    </b-alert>

    <b-alert :show.sinc="ui.showSuccess" variant="success" class="mt-5">
      {{$t('ValidateAccount.success')}}
      <br/>
    </b-alert>

    <b-alert :show="showResendMessage" variant="success" class="mt-5">
      {{ $t('email.resent') }}
    </b-alert>
    <b-alert :show.sinc="codeAttempts >= maxCodeAttempts" variant="danger" class="mt-5">
      {{$t('Code.maxAttempts')}}
    </b-alert>

    <div class="code-input-container mt-4" v-if="needCode">
      <b-input v-for="index in 4"
             :key="index"
             v-model="code[index - 1]"
             @keyup="handleKeyup(index, $event)"
             @keydown="filterKey($event)"
             maxlength="1"
             :class="{'input-success': ui.showSuccess, 'input-error': ui.showError}"
             type="text"
             class="code-input"
             :ref="'input' + index"/>
    </div>

    <div class="d-flex mt-5 flex-column flex-lg-row justify-content-center align-items-center">
      <div class="content">{{$t('email.needResend')}}</div>
      <div class="link-main-color ml-lg-2 cursor-pointer" @click="resendValidateAccountMailCode">{{$t('email.sendAgain')}}</div>
      <div class="content ml-lg-2" v-if="resendTimer>0">{{`(${resendTimer}s)`}}</div>
    </div>

    <div class="mt-4 d-flex justify-content-center">
      <b-button variant="danger" class="px-5" @click="logout">
        {{ $t('Logout') }}
      </b-button>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'
import _ from "lodash";

export default {

  name: 'ValidateAccountComponent',

  props:{
    usernameProps:{
      required:true,
    },
    passwordProps:{
      required:true,
    }
  },

  data () {
    return {
      validationInProgress: false,
      username:null,
      password:null,
      ui: {
        showSuccess: false,
        showError: false
      },
      inputFields: 4,
      code: ['', '', '', ''],
      needCode:null,
      showResendMessage: false,
      resendTimer: 0,
      codeAttempts: 0,
      maxCodeAttempts: 3
    }
  },

  emits: ['showLoginView'],

  created() {
    this.debouncedValidateCode = _.debounce(this.validateCode, 500);
  },


  mounted () {
    this.username = this.$route.query.username || this.usernameProps;
    this.password = this.passwordProps
    this.needValidationCode()
  },


  watch: {
    'codeAttempts': function (newVal) {
      if(newVal >= this.maxCodeAttempts){
        this.resendValidateAccountMailCode()
      }
    },
  },
  methods: {

    handleKeyup(index, event) {
      if (event.key >= '0' && event.key <= '9') {
        if (index < 4) {
          this.$refs['input' + (index + 1)][0].focus();
        }
      } else if (event.key === 'Backspace') {
        if (index > 1 && this.code[index - 1] === '') {
          this.$refs['input' + (index - 1)][0].focus();
        }
      }
      if (this.code.every(value => value.length === 1)) {
        this.debouncedValidateCode();
        if (index === 4) {
          this.$refs['input' + index][0].blur();
        }
      }
    },
    filterKey(event) {
      this.ui.showSuccess=null
      this.ui.showError=null
      const isNumberKey = (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105);
      if (!isNumberKey && event.keyCode !== 8) {
        event.preventDefault();
      }
    },

    validateCode() {
      if (this.validationInProgress || this.codeAttempts >= this.maxCodeAttempts) {
        return;
      }
      this.codeAttempts++
      this.validationInProgress = true;
      const verificationCode = this.code.join('');
      this.validateAccount(verificationCode);
    },

    validateAccount (code) {
      const data = new FormData()
      data.append('code', code)
      data.append('username', this.username)

      api({
        method: 'POST',
        url: `/authentication/validateAccountCode`,
        data: data
      })
        .then(() => {
          this.ui.showSuccess = true
          this.validationInProgress = false;
          this.startAlertTimer();
          setTimeout(() => {
            this.autoLogin()
          }, 3000);
        })
        .catch((error) => {
          this.code = ['', '', '', '']

          if (!error.response) {
            console.log("error", error)
          }

          this.validationInProgress = false;
          this.startAlertTimer();
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    needValidationCode () {
      const data = new FormData()
      data.append('username', this.username)

      api({
        method: 'POST',
        url: `/authentication/needValidateCode`,
        data: data
      })
        .then(() => {
          this.needCode = true
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    backToLogin () {
      this.$router.push('/login') //si on met pas ca : ca garde le token et l'id dans l'url et ca recharge (mounted) le component validateAccount avec une erreur à la connexion :/
      this.$emit('showLoginView')
    },

    startAlertTimer() {
      setTimeout(() => {
        this.ui.showSuccess = false;
        this.ui.showError = false;
      }, 5000);
    },

    async autoLogin() {
      let data = {
        username: this.username,
        password: this.password
      }
      let formData = new FormData()
      formData.append('isForIndividual', "true")
      formData.append('username', data['username'])
      formData.append('password', data['password'])

      await api({
        method: 'POST',
        url: '/authentication/beforeLogin',
        data: formData
      })
        .then(async (response) => {
          // login
          await this.$store.dispatch('LogIn', data)
            .then(async () => {
              this.ui.showError = false
              await this.$router.push({name: localStorage.getItem('selectedReason')})
            })
            .catch((error) => {
              if (error.toString() === 'Locked') {
                this.ui.showErrorMessage = this.$i18n.t('Profile.forbidden.error')
                this.ui.showError = true
              }
            })
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }

          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
            if (error.response.data.message === 'account.not.validated.error') {
              this.ui.showValidateAccountError = true
            }
          }
          if (error.response && error.response.status === 423) {
            this.ui.showErrorMessage = this.$i18n.t('account.locked.error')
            this.ui.showError = true
          }

          //ces 2 cas ne devraient jamais arriver car seuls les particuliers ont accès à l'inscription sur le GP
          if (error.response && error.response.status === 468) {
            //PRO
            this.ui.showErrorMessage = this.$i18n.t('Login.error.connect.on.pro')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 467) {
            //OTHERS
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }

          if (error.response && error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },

    resendValidateAccountMailCode() {
      if (this.resendTimer > 0) {
        return; // Ne fait rien si le timer n'est pas écoulé ou si le max d'essais est atteint
      }
      this.codeAttempts=0
      this.showResendMessage = true;
      setTimeout(() => {
        this.showResendMessage = false;
      }, 3000); // Cache le message après 3 secondes

      let formData = new FormData()
      formData.append('username', this.username.trim())

      api({
        method: 'POST',
        url: `/authentication/resendValidateAccountMailCode`,
        data: formData
      })
        .then(() => {
          this.ui.showResendValidateAccountMailSuccess = true
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
      this.startResendTimer();
    },

    startResendTimer() {
      this.resendTimer = 60;
      const interval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },

    goToHome() {
      this.$router.push({
        name: 'Home'
      })
    },

    async logout () {
      await this.$store.dispatch('LogOut')
      this.$emit('showLoginView')
    }
  }

}
</script>

<style scoped>
.code-input-container {
  display: flex;
  justify-content: center;
  gap: 8%;
}

.code-input {
  width: 70px;
  height: 90px;
  max-width: 15%;
  max-height: 10vh;
  text-align: center;
  font-size: 2em;
  border: solid 1px var(--main-black-light);
  background-color: var(--main-black-medium)!important;
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.3);
  transition: width 0.2s, height 0.2s;
}

.code-input:focus {
  border-color: var(--main-yellow-medium)!important;
  box-shadow: inset 0 0 5px rgba(48,48,48,1), 0 0 6px 2px var(--main-yellow-medium);
}

.input-success{
  border-color: var(--main-green-medium)!important;
  box-shadow: inset 0 0 5px rgba(48,48,48,1), 0 0 6px 2px var(--main-green-medium);
}

.input-error{
  border-color: var(--main-red-medium) !important;
  box-shadow: inset 0 0 5px rgba(48,48,48,1), 0 0 6px 2px var(--main-red-medium);
}

@media (max-width: 991px) {
  .code-input {
    width: 50px;
    height: 70px;
  }

}

.logout-link {
  color: var(--main-yellow-medium);
  font-family: "KumbhSans-Regular", "Arial", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
}
.logout-link:hover {
  cursor: pointer;
  color: var(--main-yellow-dark)
}



</style>



// WEBPACK FOOTER //
// src/views/auth/components/ValidateAccountComponent.vue